import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { FirebaseService } from "app/services/firebase.service";
import { FirebaseListObservable, FirebaseObjectObservable } from "angularfire2/database";
import { AngularFireModule } from 'angularfire2';
import { environment } from 'app/../environments/environment';

@Injectable()
export class UserService {
	private db;
	private currenUser;
	users: FirebaseListObservable<User[]>;

	secondApp: firebase.app.App;

	constructor(
		private firebaseSerive: FirebaseService,
	) {
		this.db = firebaseSerive.db;
		this.loadUserDb();
	}

	loadUserDb() {
		window.dispatchEvent(new Event('loading'));
		this.users = this.db.list('/users') as FirebaseListObservable<User[]>
		this.users.subscribe(data => {
			this.triggerDataChange();
		});
	}

	triggerDataChange() {
		window.dispatchEvent(new Event('data-loaded'));
	}

	getUsers() {
		return this.users;
	}

	getUser(id: string) {
		return this.db.object('/users/' + id) as FirebaseObjectObservable<User>;
	}

	addUser(user: User) {
		this.users.push(user);
	}

	getImeii(id: string){
		return this.db.object('/imeii/'+id) as FirebaseObjectObservable<Imeii>
	}

	saveImeii(imeii: Imeii) {
		if (imeii.$key) {
            var imeii_ref = this.db.object('/imeii/' + imeii.$key) as FirebaseObjectObservable<Imeii>

            delete imeii.$key;
            return imeii_ref.set(imeii)
        }
	}

	updateImeii(id: string, data: Imeii){
		var imeii = this.getImeii(id)
		data.updated_at = (new Date()).getTime();
		return imeii.update(data)
	}

	saveUser(user: User) {
		if(user.$key) {
			let user_ref = this.getUser(user.$key);
			delete user.$key;
			delete user.password;
			return user_ref.set(user);
		}
		return false;
	}

	updateUser(id: string, data: User) {
		var user = this.getUser(id);
		data.updated_at = (new Date()).getTime();
		var imeii = new Imeii()
		imeii.imeii = data.imeii;
		imeii.user_email = data.email;
		this.updateImeii(id, imeii)
		return user.update(data);
	}

	create_firebaase_user(user: User) {
		var self = this;

		if(!self.secondApp) {
			self.secondApp = firebase.initializeApp(environment.firebase, 'Secondary');
		}

		var promise = new Promise((resolve, reject) => {
			self.secondApp.auth().createUserWithEmailAndPassword(user.email, user.password).then(new_user => {
				if (new_user) {
					var imeii = new Imeii();
					user.$key = new_user.uid;
					imeii.$key = new_user.uid;
					imeii.imeii = user.imeii;
					imeii.user_email = user.email;
					self.saveUser(user);
					self.saveImeii(imeii);
					resolve(user);
				}
				else {
					reject('Unknown error');
				}
			}).catch(error => {
				reject(error.message);
			})
		})

		return promise;
	}

	deleteUser(id: string){
		if(!id){
			return new firebase.Promise<void>((resolve, reject) => {
				reject(null);
			})
		}
		var result = this.users.remove(id);
		this.triggerDataChange();
		return result;
	}
}

export class User {
	$key?: string;
	uid?: string;
	email?: string = '';
	password?: string = '';
	fullname?: string = '';
	employee_number?: string = '';
	// gender?: string = '';
	title?: string = '';
	companies?: string[] = [];
	phone?: string = '';
	position?: string = '';
	level?: string = 'sales';
	imeii?: string = '';

	created_at?: number;
	updated_at?: number;

	constructor() {
		var now = new Date();
		this.created_at = now.getTime();
		this.updated_at = now.getTime();
	}
}

export class Imeii {
	$key?: string;
	imeii?: string = '';
	user_email?: string = '';

	created_at?: number;
	updated_at?: number;

	constructor() {
		var now = new Date();
		this.created_at = now.getTime();
		this.updated_at = now.getTime();
	}
}





// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/user.service.ts